<script>
import Vue from 'vue';

Vue.component('HTMLFooter', {
  template: `
  <div>
    <footer>
      © 2017-2024 Uninet Kft. <span>- Minden jog fenntarva.</span>
    </footer>
  </div>
  `
});
</script>


// WEBPACK FOOTER //
// tpl_footer.vue?5e110f80